import React from "react";
import { Badge } from "react-bootstrap";

interface IBadgeProps {
  children: React.ReactNode;
}

const BranchTypeBadge: React.FC<IBadgeProps> = ({ children }) => {
  return (
    <Badge
      bg="additional-violet"
      text="primary"
      className="px-2 py-1 fs-14 rounded-1 fw-normal lh-base"
    >
      {children}
    </Badge>
  );
};

export default BranchTypeBadge;
